<p-breadcrumb
  [model]="[
    {
      label: 'Valores de atributos',
      routerLink: ['/variation-attribute-values']
    },
    {
      label: variationAttributeValueId()
        ? 'Editar Valor de Atributo'
        : 'Novo Valor de Atributo',
      routerLink: variationAttributeValueId()
        ? ['/variation-attribute-values/update/' + variationAttributeValueId()]
        : ['/variation-attribute-values/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(variationAttributeValueId()){
        <h5 class="font-bold">Editar Valor de Atributo</h5>
        <p>Confira e atualize informações</p>
        }@else {
        <h5 class="font-bold">Cadastrar Valor de Atributo</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div class="flex justify-end gap-5 items-center">
        @if(variationAttributeValueId()){
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <div class="flex gap-2 items-center">
            <p-toggleswitch formControlName="isActive" />
            {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
          </div>
        </div>
        }
        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/variation-attribute-values"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="card mt-5 space-y-5">
    <h5 class="font-bold">Informações gerais</h5>

    <div class="flex flex-wrap lg:flex-nowrap gap-5">
      <div class="w-full">
        <label for="variationAttributeId"> Atributo *</label>
        <div>
          <p-select
            [options]="attributesDropdown()"
            [loading]="selectLoading()"
            formControlName="variationAttributeId"
            optionLabel="label"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            placeholder="Selecione o atributo"
            class="w-full"
          >
          </p-select>
        </div>
        <app-form-error [control]="formGroup.get('variationAttributeId')" />
        <app-form-server-error
          [control]="formGroup.get('variationAttributeId')"
        />
      </div>
      <div class="w-full">
        <label for="value"> Valor *</label>
        <input
          pInputText
          type="text"
          formControlName="value"
          class="w-full"
          placeholder="Ex: Prata, 512GB"
        />
        <app-form-error [control]="formGroup.get('value')" />
        <app-form-server-error [control]="formGroup.get('value')" />
      </div>
      <div class="w-full">
        <label for="sortOrder"> Ordem </label>
        <input
          pInputText
          type="number"
          formControlName="sortOrder"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('sortOrder')" />
        <app-form-server-error [control]="formGroup.get('sortOrder')" />
      </div>
    </div>

    <div class="w-full">
      <label for="displayName"> Nome de exibição *</label>
      <input
        pInputText
        type="text"
        formControlName="displayName"
        class="w-full"
        placeholder="Ex:  Prata, 512GB"
      />
      <app-form-error [control]="formGroup.get('displayName')" />
      <app-form-server-error [control]="formGroup.get('displayName')" />
    </div>

    <div class="w-full">
      <label for="extraData"> Dados extras </label>
      <input
        pInputText
        type="text"
        formControlName="extraData"
        class="w-full"
        placeholder="Ex: #cecece"
      />
      <app-form-error [control]="formGroup.get('extraData')" />
      <app-form-server-error [control]="formGroup.get('extraData')" />
    </div>
  </div>

  @if(loading()) {
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
  </div>
  }
</form>
